import React, { useState, useEffect } from "react";
import InfoCard from "../components/InfoCard";

const Section6 = ({ contenuti }) => {
    const [isMobile, setIsMobile] = useState(false);
    const contenutiArray = Array.isArray(contenuti) ? contenuti : Object.values(contenuti);
    const layout_contenuto = contenutiArray[0];
    const { titolo_1, titolo_2, immagine_url } = layout_contenuto;


    const list_cards = contenutiArray.slice(1);;


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 992);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);




    return (
        <>
            <div
                className="container-fluid d-flex flex-column align-items-center position-relative"
                style={{
                    padding: "74px 16px",
                    gap: "16px",
                    backgroundImage: `url(${immagine_url})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className="position-absolute w-100 head-onda reverse">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 1440 50"
                        preserveAspectRatio="none"
                        className="w-100"
                    >
                        <path
                            fill="#fff" // Colore di Bootstrap bg-light
                            d="M0,50L80,45C160,40,320,30,480,25C640,20,800,20,960,25C1120,30,1280,40,1360,45L1440,50L1440,50L1360,50C1280,50,1120,50,960,50C800,50,640,50,480,50C320,50,160,50,80,50L0,50Z"
                        ></path>
                    </svg>
                </div>
                {/* Titolo della sezione */}
                <div className="container title-section text-center">
                    <h2
                        className={`white-text ${isMobile
                            ? "d-inline-block d-lg-none title-section-mobile"
                            : "d-none d-lg-inline-block title-section"
                            }`}
                    >
                        {titolo_1}
                    </h2>{" "}
                    <h2
                        className={`light-green-text ${isMobile
                            ? "d-inline-block d-lg-none title-section-mobile"
                            : "d-none d-lg-inline-block title-section"
                            }`}
                    >
                        {titolo_2}
                    </h2>

                </div>

                {/* Contenitore per le righe delle card */}
                <div className="container d-flex flex-column m-0 p-0">
                    <div className="row">
                        {list_cards.slice(0, 3).map((card, index) => {

                            const { immagine_url, sottotitolo_it, descrizione_it } = card;
                            return (
                                <div key={index} className="col-md-4">
                                    {/* 3 card per riga senza margini e padding */}
                                    <InfoCard
                                        img={immagine_url}
                                        subtitle={sottotitolo_it}
                                        text={<span dangerouslySetInnerHTML={{ __html: descrizione_it }} />}
                                    />
                                </div>
                            );
                        })}
                    </div>
                    <div className="row">
                        {list_cards.slice(3, 6).map((card, index) => {
                            const { immagine_url, sottotitolo_it, descrizione_it } = card;
                            return (
                                <div key={index + 3} className="col-md-4">
                                    {/* 3 card per riga senza margini e padding */}
                                    <InfoCard
                                        img={immagine_url}
                                        subtitle={sottotitolo_it}
                                        text={<span dangerouslySetInnerHTML={{ __html: descrizione_it }} />}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="position-absolute w-100 foot-onda-reverse">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 1440 50"
                  preserveAspectRatio="none"
                  className="w-100"
                >
                  <path
                    fill="#fff" // Colore di Bootstrap bg-light
                    d="M0,50L80,45C160,40,320,30,480,25C640,20,800,20,960,25C1120,30,1280,40,1360,45L1440,50L1440,50L1360,50C1280,50,1120,50,960,50C800,50,640,50,480,50C320,50,160,50,80,50L0,50Z"
                  ></path>
                </svg>
              </div>
            </div>
        </>
    );
};

export default Section6;
